module.exports = __webpack_public_path__ + "img/edge.1e61b234.svg";